import { Box, Card, CardActions, CardContent, Typography } from "@mui/material";

interface DescriptionComponent {
    office: any;
}
export const DescriptionComponent = ({ office }: DescriptionComponent) => {
    return (
        <Box className="recentNotesWrapper">
            <Box className="subHead2">
                <Typography variant="h3" className="primaryColor" style={{ marginBottom: '5px' }}>
                    Description
                </Typography>
            </Box>
            {
                office?.description && (
                    <Box className="recentNotesContainer" sx={{ pr: 2 }}>
                        <Card elevation={0} sx={{ mb: 1 }}>
                            <CardContent>
                                <Typography variant="body1">{office?.description}</Typography>
                            </CardContent>
                            {/* <CardActions disableSpacing>
                                <Typography variant="caption" fontStyle={'italic'}>
                                    Created on: <i>{office?.createdOn}</i>
                                </Typography>
                            </CardActions> */}
                        </Card>
                    </Box>
                )
            }
        </Box>
    );
}